<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">{{ this.pageName }}</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item">Settings</li>
                            <li class="breadcrumb-item active">{{ this.pageName }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>{{ this.pageName }}</h4>
                </div>
                <div class="card-body">
                    <section class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 col-sm-6">
                                    <div class="form-group"><label>Pickup Opening Time</label>
                                        <input type="time" required class="form-control"
                                               v-model="configuration.opening_time"
                                               @change="markTimesChanged">
                                        <span v-if="configuration.errors.opening_time"
                                              class="text-danger text-small">{{
                                                configuration.errors.opening_time
                                            }}</span>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6">
                                    <div class="form-group"><label>Pickup Closing Time</label>
                                        <input type="time" required class="form-control"
                                               v-model="configuration.closing_time"
                                               @change="markTimesChanged">
                                        <span v-if="configuration.errors.closing_time"
                                              class="text-danger text-small">{{
                                                configuration.errors.closing_time
                                            }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-sm-6">
                                    <div class="form-group"><label>Delivery Opening Time</label>
                                        <input type="time" required class="form-control"
                                               v-model="configuration.delivery_opening_time"
                                               @change="markTimesChanged">
                                        <span v-if="configuration.errors.delivery_opening_time"
                                              class="text-danger text-small">{{
                                                configuration.errors.delivery_opening_time
                                            }}</span>
                                    </div>
                                </div>

                                <div class="col-12 col-sm-6">
                                    <div class="form-group">
                                        <label>Delivery Closing Time</label>
                                        <input type="time" required class="form-control"
                                               v-model="configuration.delivery_closing_time"
                                               @change="markTimesChanged">
                                        <span v-if="configuration.errors.delivery_closing_time"
                                              class="text-danger text-small">{{
                                                configuration.errors.delivery_closing_time
                                            }}</span>
                                    </div>
                                </div>
                            </div>



                            <div class="row">
                                <div class="col-12 col-sm-6">
                                    <div class="form-group"><label>Minimum Delivery Amount</label>
                                        <input type="number" required class="form-control"
                                               v-model="configuration.minimum_order_amount">
                                        <span v-if="configuration.errors.minimum_order_amount"
                                              class="text-danger text-small">{{
                                                configuration.errors.minimum_order_amount
                                            }}</span>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="form-group">
                                        <label>Allowed Payment Methods</label>
                                        <v-select multiple v-model="configuration.allowed_payment_gateways" :options="paymentGateways" label="Allowed payment gateways">
                                        </v-select>
                                        <span v-if="configuration.errors.allowed_payment_gateways"
                                              class="text-danger text-small">{{
                                                configuration.errors.allowed_payment_gateways
                                            }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-1">
                                <button type="submit" class="btn btn-primary" @click="handleSaveClick">
                                    Update
                                    <i class="fa fa-spinner fa-spin" v-if="saving"/>
                                </button>
                            </div>
                        </div>
                    </section>
                </div>
            </section>
        </div>

        <div class="modal fade business-hours-conflict-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Custom Store Times Detected</h4>
                        <button type="button" data-dismiss="modal" aria-label="Close" class="close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>
                            The following stores have custom pickup/delivery times set. Choose whether to reset them
                            to use these general business hours, or leave their custom times unchanged.
                        </p>
                        <ul class="mb-0">
                            <li v-for="store in customStores" :key="store.id" class="text-danger">
                                {{ store.name }}<span v-if="store.area"> - {{ store.area }}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" :disabled="saving"
                                @click="updateBusinessHoursSettings(false)">
                            Update General Only
                        </button>
                        <button type="button" class="btn btn-danger" :disabled="saving"
                                @click="updateBusinessHoursSettings(true)">
                            Update For All Stores
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import DeleteAlert from "../../Shared/Mixins/DeleteAlert";
import PaginationMixin from "../../Shared/Mixins/PaginationMixin";

export default {
    metaInfo: {title: 'Configurations'},
    props: [
        'configurations',
        'configurationEnums',
        'pageName',
        'routeName',
        'paymentGateways',
        'storesWithCustomTimes',
    ],
    layout: Layout,
    name: 'ConfigurationIndex',
    mixins: [
        DeleteAlert,
        PaginationMixin,
    ],
    data() {
        return {
            saving: false,
            hasTimeChanges: false,
            customStores: this.storesWithCustomTimes || [],
            configuration: this.$inertia.form({
                opening_time: null,
                closing_time: null,
                delivery_opening_time: null,
                delivery_closing_time: null,
                minimum_order_amount: null,
                allowed_payment_gateways: {},
                update_all_stores: false,
            }),
        };
    },
    watch: {
        storesWithCustomTimes(value) {
            this.customStores = value || [];
        },
    },
    mounted() {
        this.hydrateForm();
    },

    methods: {
        hydrateForm() {
            this.configuration.opening_time = this.normalizeTime(this.configurations.opening_time);
            this.configuration.closing_time = this.normalizeTime(this.configurations.closing_time);
            this.configuration.delivery_opening_time = this.normalizeTime(this.configurations.delivery_opening_time);
            this.configuration.delivery_closing_time = this.normalizeTime(this.configurations.delivery_closing_time);
            this.configuration.minimum_order_amount = this.configurations.minimum_order_amount;
            this.configuration.allowed_payment_gateways = this.configurations.allowed_payment_gateways;
            this.configuration.update_all_stores = false;
            this.hasTimeChanges = false;
            this.customStores = this.storesWithCustomTimes || [];
        },
        normalizeTime(value) {
            return value ? String(value).substring(0, 5) : null;
        },
        markTimesChanged() {
            this.hasTimeChanges = true;
        },
        handleSaveClick() {
            if (this.hasTimeChanges && this.customStores.length > 0) {
                $('.business-hours-conflict-modal').modal('show');
                return;
            }

            this.updateBusinessHoursSettings(false);
        },
        async updateBusinessHoursSettings(updateAllStores = false) {
            this.saving = true;
            this.configuration.update_all_stores = updateAllStores;

            const options = {
                preserveScroll: true,
                onSuccess: () => {
                    this.saving = false;
                    this.hasTimeChanges = false;
                    $('.business-hours-conflict-modal').modal('hide');
                    if (updateAllStores) {
                        this.customStores = [];
                    }
                },
                onError: () => {
                    this.saving = false;
                }
            };

            this.configuration.post(route(this.routeName), options);
        },
    }
}
</script>
